// src/evaluations/AssessmentModeChip.js
// Etiqueta de la modalidad del assessment (PLAN_UNIFICACION_ASSESSMENT.md):
// completo en el color principal y simple en azul. Se usa en la tabla de
// "Mis Assessments" y en el encabezado del assessment.
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isSimpleAssessment } from './assessmentMode';

export default function AssessmentModeChip({ evaluation, size = 'small', sx }) {
    const { t } = useTranslation();
    const simple = isSimpleAssessment(evaluation);

    return (
        <Chip
            size={size}
            color={simple ? 'info' : 'primary'}
            label={simple ? t('evaluations.modeChipSimple') : t('evaluations.modeChipComplete')}
            sx={sx}
        />
    );
}
